import { faCheck, faCheckSquare, faPencilAlt, faPlus, faSquare, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useEffect, useState } from 'react';
import { Button, FormGroup, Input, InputGroup, InputGroupText, Label } from 'reactstrap';
import { useAuth0 } from '../../../../auth0/reactAuth0Spa';
import { checkLoginForError, formatBearerToken } from '../../../../Common.functions';
import { DepartmentContext } from '../../../../DepartmentWrapper';
import { fetchDataAgnostic, putData } from '../../../../Services/dataApi';
import { toast } from 'react-toastify';
import { clone } from '../../../../Services/schedule';
import style from './SeasonPopover.style';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import RezRateTable from 'Body/RezRATE/Common/RezRateTable/RezRateTable';

const SeasonPopover = ({ seasons = [], selectedSeason, setSelectedSeason, fetchSeasons, setShowSeasonPopover }) => {
  const [seasonChoices, setSeasonChoices] = useState([]); // Actual use

  const [isUpdating, setIsUpdating] = useState();
  const [lastUpdatedRow, setLastUpdatedRow] = useState();
  const [allowPreScreen, setAllowPreScreen] = useState(false);
  const [token, setToken] = useState();

  const { getTokenSilently, loginWithRedirect } = useAuth0();
  const dContext = useContext(DepartmentContext);
  const { department = {} } = dContext;
  const history = useHistory();

  useEffect(() => {
    if (seasons) {
      seasons.forEach((s, i) => {
        s.index = i;
        s.editMode = false;
      });

      if (selectedSeason) {
        let sSeason = seasons.find((s) => {
          return selectedSeason.pk_Season == s.pk_Season; //s.Active;
        });

        if (!sSeason) {
          sSeason = seasons.find((s) => {
            return s.Active;
          });
        }

        if (sSeason) {
          setSelectedSeason(sSeason);
        }
      }

      setSeasonChoices(
        clone(
          seasons.sort((a, b) => {
            // Sort by date
            const textA = a.UserLast;
            const textB = b.UserLast;
            return textA < textB ? -1 : textA > textB ? 1 : 0;
            //  return new Date(b[key]) - new Date(a[key]);
          }),
        ),
      );
    }
  }, [JSON.stringify(seasons)]);

  useEffect(() => {
    getSeasonSettings();
  }, [JSON.stringify(selectedSeason)]);

  useEffect(() => {
    getTokenSilently()
      .then((token) => {
        setToken(token);
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  }, []);

  const getSeasonSettings = () => {
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/season',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
          },
          formatBearerToken(token),
        )
          .then((res) => {
            setAllowPreScreen(res.data.AllowPrescreen);
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const handleChange = (index, key, season, value) => {
    const newSeasons = clone(seasonChoices);
    const newSeason = clone(season);
    newSeason[key] = value;
    setLastUpdatedRow(newSeason);

    if (key != 'SeasonName') {
      newSeasons[index] = newSeason;
      setLastUpdatedRow(newSeason);
      setSeasonChoices(newSeasons);
    }

    if (key === 'editMode') {
      newSeasons[index] = newSeason;
      newSeasons.forEach((s, i) => {
        if (i != index) {
          s.editMode = false;
        }
      });
      setSeasonChoices(newSeasons);
    }
    if (key === 'Active' || key === 'EnablePrescreenMode') {
      setLastUpdatedRow(null);
      saveChanges(newSeason);
    }
  };

  const saveChanges = (seasonToSave, cb) => {
    const pk_Season = seasonToSave.pk_Season;

    delete seasonToSave.editMode;
    delete seasonToSave.fk_Department;
    delete seasonToSave.index;
    delete seasonToSave.pk_UUID_FM;
    delete seasonToSave.pk_Season;
    delete seasonToSave.column;
    delete seasonToSave.formatExtraData;
    delete seasonToSave.headerAttrs;
    delete seasonToSave.Type;

    let seasonToSaveActual = {
      Active: seasonToSave.Active ? 1 : 0,
      SeasonName: seasonToSave.SeasonName,
      AllowPrescreen: seasonToSave.AllowPrescreen ? 1 : 0,
      EnableUnlockedEvaluation: seasonToSave.EnableUnlockedEvaluation ? true : false,
      EnablePrescreenMode: seasonToSave.EnablePrescreenMode ? true : false,
      EnablePrescreenQuestionnaire: seasonToSave.EnablePrescreenQuestionnaire ? true : false,
      EnableEvaluationQuestionnaire: seasonToSave.EnableEvaluationQuestionnaire ? true : false,
    };

    setIsUpdating(true);

    getTokenSilently()
      .then((token) => {
        putData(
          'department/season',
          { pk_Department: dContext.department.pk_Department, pk_Season: pk_Season },
          { seasonObject: seasonToSaveActual },
          formatBearerToken(token),
        )
          .then((res) => {
            toast.success('Saved Season!');
            setIsUpdating(false);
            if (fetchSeasons) {
              fetchSeasons();
            }

            if (cb) {
              cb();
            }
          })
          .catch((err) => {
            toast.error('Error saving Season!');
            if (cb) {
              cb();
            }
            setIsUpdating(false);
          });
      })
      .catch((err) => {
        toast.error('Error saving Season!');
        if (cb) {
          cb();
        }
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const headerFormatter = (column, colIndex) => {
    return <div style={style.headerStyle}>{column.text}</div>;
  };

  const cellFormatter = (cell, data) => {
    const { row, rowIndex, formatExtraData, SeasonName, Active, editMode } = data;

    return (
      <div style={{ ...style.headerStyle, padding: 10 }}>
        <InputGroup>
          {department.EnableSuperUser ? (
            <>
              <FormGroup
                switch
                style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <Input
                  disabled={isUpdating || !department.EnableSuperUser}
                  style={{ zIndex: 90 }}
                  type="switch"
                  role="switch"
                  label=""
                  size={3}
                  checked={Active}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleChange(rowIndex, 'Active', data, Active ? false : true);
                  }}
                />
              </FormGroup>
            </>
          ) : null}
          <Input
            style={{ textAlign: 'center' }}
            disabled={!editMode || isUpdating}
            type="text"
            defaultValue={SeasonName}
            value={editMode ? lastUpdatedRow.SeasonName : SeasonName}
            onClick={(e) => {
              if (editMode) {
                e.stopPropagation();
              }
            }}
            onChange={(e) => {
              handleChange(rowIndex, 'SeasonName', data, e.target.value);
            }}
          />
          {!editMode || isUpdating ? (
            <div
              style={{
                position: 'absolute',
                left: 0,
                top: 0,
                width: '100%',
                height: '100%',
              }}
              onClick={(e) => {}}
            ></div>
          ) : null}
          <Button
            color={
              editMode
                ? lastUpdatedRow && lastUpdatedRow.SeasonName !== SeasonName && lastUpdatedRow.SeasonName
                  ? 'success'
                  : 'danger'
                : 'warning'
            }
            onClick={(e) => {
              e.stopPropagation();
              if (editMode) {
                if (lastUpdatedRow && lastUpdatedRow.SeasonName !== SeasonName) {
                  if (lastUpdatedRow.SeasonName) {
                    saveChanges(lastUpdatedRow, () => {
                      handleChange(rowIndex, 'editMode', data, false);
                      setLastUpdatedRow(null);
                    });
                  } else {
                    handleChange(rowIndex, 'editMode', data, false);
                  }
                } else {
                  handleChange(rowIndex, 'editMode', data, false);
                }
              } else {
                setLastUpdatedRow(row);
                handleChange(rowIndex, 'editMode', data, true);
              }
            }}
          >
            <FontAwesomeIcon
              icon={
                editMode
                  ? lastUpdatedRow && lastUpdatedRow.SeasonName !== SeasonName && lastUpdatedRow.SeasonName
                    ? faCheck
                    : faTimes
                  : faPencilAlt
              }
            />
          </Button>
        </InputGroup>
      </div>
    );
  };

  const makeColumns = () => {
    const newColumns = [];
    const headers = [{ SeasonName: '', dataField: 'SeasonName' }];

    headers.forEach((header) => {
      newColumns.push({
        dataKey: header.dataField,
        text: header.SeasonName,
        SeasonName: header.SeasonName,
        formatter: cellFormatter,
        headerFormatter: headerFormatter,
        // classes: 'timeSlot',
        style: (data) => {
          const { cell, row, rowIndex, colIndex } = data;
          const cStyle = { verticalAlign: 'middle', cursor: 'pointer' };
          const backgroundColor = selectedSeason && row.pk_Season == selectedSeason.pk_Season ? 'var(--rr-primary-soft)' : null;
          return { ...cStyle, backgroundColor };
        },
        headerStyle: (column, colIndex) => {
          const hStyle = { verticalAlign: 'middle' };
          switch (column.text) {
            case 'Active':
              hStyle.width = 50;
              break;
            case 'Modify':
              hStyle.width = 50;
              break;
          }
          return hStyle;
        },
        // isTime: true,
        formatExtraData: { SeasonName: header.SeasonName },
        events: {
          onClick: (data) => {
            const { e, column, columnIndex, row, rowIndex } = data;
            if (dContext.selectSeason) {
              dContext.selectSeason(row);
            } else {
              dContext.setSeason(row);
            }
            setSelectedSeason(row);
            setShowSeasonPopover(false);
            if (window.location.pathname.includes('administrator/schedule')) {
              history.push('/administrator');
            }
          },
        },
        headerEvents: {
          onClick: (e, column, columnIndex) => {},
        },
        headerAttrs: {
          // id: 'timeSlotHeader',
        },
        // attrs: (data) => {
        //   // const { cell, row, rowIndex, colIndex } = data;
        //   // return { 'data-testid': `${row.SeasonName}_${rowIndex}` };
        //   // return { id: `timeSlot_${row.pk_Timeslot}` };
        // },
      });
    });
    return newColumns;
  };

  return (
    <div>
      <div style={style.tableContainer}>
        <RezRateTable
          columns={makeColumns()}
          data={seasonChoices.sort((s) => {
            return s.pk_Season;
          })}
          noDataMessage="No seasons available"
          tableBodyHeight="100%"
        />
      </div>
    </div>
  );
};

export default SeasonPopover;
